export enum StylePatterns {
  ELEMENT_WIDTH = "w-11/12 md:w-4/5 lg:w-3/5 max-w-2xl",
  ELEMENT_WIDTH_SMALL = "w-4/5 lg:w-3/5 max-w-80",

  SUB_INPUTS_STYLE = "z-1 block p-2 w-full appearance-none focus:outline-none bg-transparent text-base",
}
